import {listElementIdArray, listTopologyDataByTpId} from '../data';
import {stageEvent} from '../event';
import {stateConst} from '../conf';

export default {
  data() {
    return {
      tpStore: {
        tpId: '',
        canvasStage: null,
        canvasLayerArray: []
      },
      tpOptions: {
        // 显示侧边栏
        showAside: true,
        // 显示属性栏
        showAttribute: false,
        // 选中激活状态
        selectedActive: true,
        // 连线激活状态
        joinLineActive: false
      }
    };
  },
  created() {
    this.$nextTick(() => {
      this.initCanvasStage();

      // 初始化一批图形ID
      listElementIdArray();
    });
  },
  methods: {
    /**
     * 初始化画布舞台
     */
    initCanvasStage() {
      this.tpStore.tpId = this.$route.query.tpId;
      if (!this.tpStore.canvasStage) {
        this.tpStore.canvasStage = stageEvent.initCanvasStage();

        // 初始化快捷键
        stageEvent.initBindCanvasShortcuts(this);
      }

      // 初始化画布舞台事件
      stageEvent.initCanvasStageEvent(this);

      // 初始化画布舞台尺寸改变事件
      stageEvent.initCanvasSizeChangeEvent(this);

      if (this.tpStore.tpId) {
        if (window.cycleRefreshStatus) {
          clearTimeout(window.tpShapeNodeStatusRefreshEvent);
          window.tpShapeNodeStatusRefreshEvent = setTimeout(() => {
            this.loadTopologyDataByTpId(this.tpStore.tpId);
          }, window.tpShapeNodeStatusRefreshTime || 3000);
        } else {
          this.loadTopologyDataByTpId(this.tpStore.tpId);
        }
      }
    },
    loadTopologyDataByTpId(tpId) {
      listTopologyDataByTpId(tpId).then(resp => {
        if (resp.code === '00000' && resp.data) {
          resp.data.nodes = resp.data.nodes || [];
          resp.data.edges = resp.data.edges || [];
          resp.data.combos = resp.data.combos || [];
          this.tpStore.canvasStage.read(resp?.data);

          // 获取拓扑数据验证状态
          this.handleNodeState(this.tpStore.canvasStage.getNodes());
          this.handleNodeState(this.tpStore.canvasStage.getEdges());
        }
      });
    },
    handleNodeState(nodes) {
      // 处理节点告警状态
      nodes?.forEach(item => {
        // 清除告警状态
        item.clearStates([stateConst.warning, stateConst.error]);
        const model = item?.getModel();
        if (model?.dataStatus === 0) {
          item.setState(stateConst.disable, true);
        } else if (model?.dataStatus === 1) {
          item.setState(stateConst.healthy, true);
        } else if (model?.dataStatus === 2) {
          item.setState(stateConst.warning, true);
        } else if (model?.dataStatus === 3) {
          item.setState(stateConst.error, true);
        }
      });
    }
  },
  destroyed() {
    this.tpStore.canvasStage = null;
    this.tpStore.canvasLayerArray = [];
    stageEvent.unbindCanvasShortcuts();
  }
};
